import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseSingleSelectComponent } from '@zaoblako/web/shared/components/base-single-select/base-single-select.component';
import { DocumentFileTemplateFindInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template/document-file-template-find.dto';
import { BasisDocumentFileTemplateService } from '@zaoblako/web/core/services/basis/basis-document-file-template.service';
import { Observable } from 'rxjs';
import { DropdownBaseQueryInterface } from '@zaoblako/shared/common/dtos/dropdown-base-query.dto';
import { PaginationFindInterface } from '@zaoblako/shared/common/dtos/pagination-find.dto';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';

@Component({
  selector: 'crm-document-file-template-single-select',
  standalone: true,
  imports: [SingleSelectComponent, SpinnerComponent],
  templateUrl: './document-file-template-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentFileTemplateSingleSelectComponent extends BaseSingleSelectComponent<DocumentFileTemplateFindInterface> {
  public availableModule = 'BASIS';

  public constructor(private readonly basisDocumentFileTemplateService: BasisDocumentFileTemplateService) {
    super();
  }

  public findById(id: number): Observable<DocumentFileTemplateFindInterface> {
    return this.basisDocumentFileTemplateService.findById(id);
  }

  public findWithPagination(
    queryParams: Partial<DropdownBaseQueryInterface>
  ): Observable<PaginationFindInterface<DocumentFileTemplateFindInterface>> {
    return this.basisDocumentFileTemplateService.findWithPagination(queryParams);
  }
}
